import { useRef, useEffect } from "react";
import {
  motion,
  useScroll,
  useTransform,
  useSpring,
  useMotionValue,
} from "motion/react";

export default function ExpandOnView({
  heading,
  description,
}: {
  heading: string;
  description: string;
}) {
  const sectionRef = useRef(null);

  // --- Sticky Progress Logic (from previous step) ---
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start 0.55", "center center"],
  });
  const stickyProgress = useMotionValue(0);
  useEffect(() => {
    const unsubscribe = scrollYProgress.on("change", (latestValue) => {
      const currentStickyValue = stickyProgress.get();
      if (latestValue > currentStickyValue) {
        stickyProgress.set(latestValue);
      }
    });
    return () => unsubscribe();
  }, [scrollYProgress, stickyProgress]);
  const smoothStickyProgress = useSpring(stickyProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
    mass: 1,
  });

  const widthProgress = "96%";
  const heightProgress = useTransform(
    smoothStickyProgress,
    [0, 0.5, 1],
    ["120px", "170px", "270px"],
  );

  const opacityTransform = useTransform(
    smoothStickyProgress,
    [0, 0.4, 0.5, 1],
    [0, 0, 0.177, 1],
  );
  const visibilityTransform = useTransform(smoothStickyProgress, (value) =>
    value <= 0.1 ? "hidden" : "inherit",
  );

  {
    /* Auto Expanding Section */
  }
  return (
    <div ref={sectionRef}>
      <motion.div
        className=" flex flex-col md:flex-row justify-bottom md:justify-between items-center overflow-hidden relative pl-0 md:pl-16 pr-4 pt-8"
        style={{ height: heightProgress }}
        ref={sectionRef}
      >
        <div className="font-gilroy-light w-full md:w-1/4 text-[32px] md:text-[40px] font-light tracking-tight mb-4 leading-[100%] ">
          {heading}
        </div>
        <motion.div
          className="text-[12px] md:text-[16px] lg:text-[20px] w-full md:w-[70%] "
          style={{
            opacity: opacityTransform,
            visibility: visibilityTransform,
          }}
        >
          {description}
        </motion.div>
      </motion.div>

      {/* Bottom Border Line */}
      <motion.div
        className="force-bottom-line border-b border-white/40 w-1/2 ml-auto"
        style={{ width: widthProgress }}
      ></motion.div>
    </div>
  );
}
